import React from 'react'

import CardHeader from './CardHeader'
import MyPieChart from './MyPieChart'
import TooltipGraficoPizza from './TooltipGraficoPizza'

export default function GraficoSimcardsOperadoras({
  portalCliente,
  handleAbrirMenuOpcoes,
  revelarOpcoesTotalSimcardsOperadora,
  menuElement,
  graficoTotalSimcardsOperadora,
  graficoTotalSimcardsOperadoraMax,
  legendaTotalSimcardsOperadora,
  totalSimcards
}) {
  return (
    <div
      className="container-dashboard-fundo-1 fundo-cor-5"
      id="grafico-simcards-operadoras"
    >
      <CardHeader
        titulo="Operadoras"
        nomeOpcao="simcardsOperadoras"
        portalCliente={portalCliente}
        handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
      />

      <div className="grupo-dash-grafico-pizza-grande">
        {revelarOpcoesTotalSimcardsOperadora === true && (
          <div className="menu-opcoes-dashboard-fundo">{menuElement}</div>
        )}
        <div className="container-operadoras">
          <div className="container-grafico-pizza-operadoras">
            <div className="caixa-grafico-pizza-operadoras">
              <MyPieChart
                key={JSON.stringify(graficoTotalSimcardsOperadora)}
                data={graficoTotalSimcardsOperadora}
                valorPercentual={graficoTotalSimcardsOperadoraMax}
                MyTooltip={(props) => (
                  <TooltipGraficoPizza
                    {...props}
                    arrDados={graficoTotalSimcardsOperadora}
                    totalSimcards={totalSimcards}
                  />
                )}
              />
            </div>
          </div>
          <div className="container-legenda-operadoras">
            {legendaTotalSimcardsOperadora}
          </div>
        </div>
      </div>
    </div>
  )
}
